import { products } from '@/mocks/products';
import ProductCard from './ProductCard';

const WA_ORCAMENTO = "https://wa.me/554891802091?text=Ol%C3%A1,%20gostaria%20de%20um%20or%C3%A7amento";

export default function ProductsSection() {
  return (
    <section id="stock" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-14">
          <span className="text-green-500 text-xs uppercase tracking-widest mb-2 block">Catálogo Completo</span>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 uppercase leading-none">Máquinas de Solda Geomembrana</h2>
          <p className="text-gray-500 text-sm mt-3 max-w-sm">
            Máquinas de solda geomembrana para PEAD, PELBD e PVC — cunha quente, extrusoras e acessórios para
            impermeabilização profissional. Envio para todo o Brasil com suporte técnico pós-venda e garantia oficial.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product) => (
            <ProductCard key={product.id} {...product} />
          ))}
        </div>
      </div>
    </section>
  );
}
